import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Grid2, useTheme, useMediaQuery } from '@mui/material';
import {
	Description as DescriptionIcon,
	LocationOn as LocationIcon,
	Business as BusinessIcon,
	// Label,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import TextFieldProps from '../../../../components/ui/Inputs/TextField';
// import { FileUploadBox } from '../../../../components/ui/Inputs/Fileupload';
import MenuTable from '../../../../components/common/Vendor/Permmission';
import permissionData from '../../../../components/common/Vendor/permmission/permmissionData';
import {
	VendorEditforms,
	Vendorforms,
	VendorRequestPUTsingle,
} from '../../../../services/api/vendor';
import MySnackbarModal from '../Vendor-ui/SnackbarModal';
import VendoRForms from './Vendor-verification';
import ContactNumberField from './ContactNumberField';

// Types for clarity
interface VendorFormValues {
	companyName: string;
	ownerName: string;
	contactNumber: string;
	email: string;
	companyAddress: string;
	country: string;
	state: string;
	city: string;
	industryType: string;
	gstNumber?: string;
	permissions: any[];
	zipCode: string;
}

interface VendorRegistrationFormProps {
	initialData?: any;
	// onSubmit: (formData: FormData) => Promise<void>;
	isEdit?: string;
	// onCancel?: () => void;
}

const VendorRegistrationForm: React.FC<VendorRegistrationFormProps> = ({
	initialData,
	// onSubmit,
	isEdit,
	// onCancel,/
}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	console.log(initialData, '');

	const [formValues, setFormValues] = useState<any>({
		companyName: '',
		ownerName: '',
		contactNumber: '',
		email: '',
		companyAddress: '',
		country: '',
		state: '',
		city: '',
		industryType: '',
		gstNumber: '',
		permissions: initialData?.permissions || permissionData || [],
		zipCode: '',
		// prefills if edit mode
	});
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [snackbarAction, setSnackbarAction] = useState<'approve' | 'reject' | null>(null);
	const [snackbarMessage, setSnackbarMessage] = useState('');
	const [loading, setLoading] = useState(false);
	// const [gstFile, setGstFile] = useState<File | null>(null);
	// const [regFile, setRegFile] = useState<File | null>(null);
	const [verificationContact, setVerificationContact] = useState(false);
	const [errors, setErrors] = useState<{ [key: string]: string }>({});
	const [contactNumbers, setContactNumbers] = useState(null);
	const navigate = useNavigate();
	useEffect(() => {
		// If initialData changes (e.g., async loaded), update form values

		if (initialData) {
			setFormValues({
				companyName: initialData?.companyName || '',
				ownerName: initialData?.ownerName || '',
				contactNumber: initialData?.mobile || '',
				email: initialData?.email || '',
				companyAddress: initialData?.companyAddress?.address || '',
				country: initialData?.companyAddress?.country || '',
				state: initialData?.companyAddress?.state || '',
				city: initialData?.companyAddress?.city || '',
				zipCode: initialData?.companyAddress?.zipCode || '',
				industryType: initialData?.companyType || '',
				gstNumber: '',
				permissions: initialData?.permissions || permissionData || [],
			});
			setContactNumbers(initialData?.mobile);

			console.log(initialData.permissions, 'initialData');
			// setRegFile(initialData?.kycDetails?.registrationDocument);
			// setGstFile(initialData?.kycDetails?.gstDocument);
		}
	}, [initialData]);
	console.log(formValues, 'formValues');

	const validateFields = () => {
		const errs: { [key: string]: string } = {};
		console.log(formValues?.companyName, 'formValues?.companyName');
		if (!formValues?.companyName?.trim()) errs.companyName = 'Company name is required';
		if (!formValues?.ownerName?.trim()) errs.ownerName = 'Owner name is required';
		if (!formValues?.contactNumber?.trim()) errs.contactNumber = 'Contact number is required';
		if (!formValues?.email?.trim()) errs.email = 'Email is required';
		else if (!/\S+@\S+\.\S+/.test(formValues.email)) errs.email = 'Email address is invalid';
		if (!formValues?.companyAddress?.trim())
			errs.companyAddress = 'Company address is required';
		if (!formValues?.country?.trim()) errs.country = 'Country is required';
		if (!formValues?.state?.trim()) errs.state = 'State is required';
		if (!formValues?.city?.trim()) errs.city = 'City is required';
		if (!formValues?.zipCode?.trim()) errs.zipCode = 'zipCode is required';
		if (!formValues?.industryType?.trim()) errs.industryType = 'Industry type is required';

		return errs;
	};

	const handleChange = (field: keyof VendorFormValues, value: string) => {
		setFormValues((prev: any) => ({ ...prev, [field]: value }));

		if (errors[field]) {
			setErrors((prev) => {
				const newErrors = { ...prev };
				delete newErrors[field];
				return newErrors;
			});
		}
	};

	const handlePermissionChange = async (updatedPermissions: any) => {
		setFormValues((prev: any) => ({ ...prev, permissions: updatedPermissions }));
		const payload = {
			businessName: formValues.businessName,
			businessType: formValues.businessType,
			firstName: formValues.firstName,
			lastName: formValues.lastName,
			email: formValues.email,
			mobile: formValues.mobile,
			companyAddress: formValues.companyAddress,
			permissions: updatedPermissions,
			gstNumber: formValues.gstNumber,
			// status: vendorData.status || 'pending',
		};

		try {
			const response = await VendorRequestPUTsingle(isEdit, payload);
			console.log(response, 'response>>>');
			if (response.success) {
				setSnackbarAction('approve');
				setSnackbarMessage(response.data.message);
				setSnackbarOpen(true);
			}
		} catch (error) {
			console.error('Error updating permissions:', error);
		}
	};

	const HandleSubmit = async () => {
		// 1️⃣ Validate form fields
		const validationErrors = validateFields();
		if (Object.keys(validationErrors).length > 0) {
			setErrors(validationErrors);
			return;
		}

		// 2️⃣ Build plain JSON object
		const payload = {
			companyName: formValues.companyName || '',
			ownerName: formValues.ownerName || '',
			mobile: formValues.contactNumber || '',
			email: formValues.email || '',
			companyAddress: {
				address: formValues.companyAddress || '',
				country: formValues.country || '',
				state: formValues.state || '',
				city: formValues.city || '',
				zipCode: formValues.zipCode || '',
			},
			companyType: formValues.industryType || '',
			gstNumber: formValues.gstNumber || '',
			termsAndConditionsAcceptance: { accepted: true },
			permissions: formValues.permissions || {},
			// gstDocument: gstFile, // only if API expects file path/base64 (not FormData)
			// companyRegistrationDocument: regFile,
		};

		// 3️⃣ Debug log payload
		console.log('=== Payload ===', payload);

		try {
			let res;
			if (isEdit) {
				res = await VendorEditforms(payload, isEdit);
				if (res?.success) {
					setSnackbarAction('approve');
					setSnackbarMessage(res.data.message);
					setSnackbarOpen(true);
					navigate('/vendor/approved');
					localStorage.removeItem('vendorperson');
				} else {
					setSnackbarAction(null);
					setSnackbarMessage('Something went wrong. Please try again.');
					setSnackbarOpen(true);
				}
			} else {
				res = await Vendorforms(payload);
				console.log(res, 'res');
				if (res.success) {
					setSnackbarAction('approve');
					setSnackbarMessage(res.data.message);
					setSnackbarOpen(true);
					navigate('/vendor/request');
					localStorage.removeItem('vendorperson');
					localStorage.removeItem('otp-verified');
					setVerificationContact(false);
				} else {
					setSnackbarAction(null);
					setSnackbarMessage('Something went wrong. Please try again.');
					setSnackbarOpen(true);
				}
			}
		} catch (error) {
			setSnackbarAction(null);
			setSnackbarMessage('Something went wrong. Please try again.');
			setSnackbarOpen(true);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Box
			sx={{
				width: '100%',
				height: 'calc(80vh - 20px)',
				bgcolor: 'white',
				borderRadius: { xs: '10px', sm: '20px' },
				mx: 'auto',
				overflowY: 'auto',
			}}
		>
			<Typography
				sx={{
					textAlign: 'left',
					color: 'black',
					fontSize: { xs: '1rem', sm: '1rem', md: '1.8rem' },
					fontWeight: 'bold',
					fontFamily: 'Quicksand',
					mb: { xs: 1, sm: 2 },
				}}
			>
				{isEdit ? 'Edit Vendor Details' : 'Vendor Registration Form'}
			</Typography>

			{/* Basic Details */}
			<Paper elevation={1} sx={{ borderRadius: '10px', mb: { xs: 3, sm: 4 } }}>
				<Box
					sx={{
						bgcolor: '#1B663C',
						// height: { xs: 48, sm: 50 },
						p: 1,
						display: 'flex',
						alignItems: 'center',
						px: { xs: 2, sm: 3 },
						borderTopRightRadius: '12px',
						borderTopLeftRadius: '12px',
					}}
				>
					<DescriptionIcon
						sx={{ color: 'white', mr: 1.5, fontSize: { xs: '1rem', sm: '1.25rem' } }}
					/>
					<Typography
						sx={{
							color: 'white',
							fontSize: { xs: '14px', sm: '1rem' },
							fontFamily: 'Poppins',
						}}
					>
						Basic Details
					</Typography>
				</Box>
				<Box sx={{ p: { xs: 2, sm: 3 } }}>
					<Grid2 container spacing={isMobile ? 2 : 3}>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							{/* <TextFieldProps
								label="Contact Number"
								placeholder="Enter Contact Number"
								value={formValues.contactNumber}
								onChange={(e) => handleChange('contactNumber', e.target.value)}
								required
								error={Boolean(errors.contactNumber)}
								helperText={errors.contactNumber || ''}
								fullWidth
							/>

							<Label />

							<Button onClick={() => setVerificationContact(true)}>
								Verification number
							</Button> */}
							<ContactNumberField
								formValues={formValues}
								handleChange={handleChange}
								setFormValues={setFormValues}
								errors={errors}
								setVerificationContact={setVerificationContact}
								contactNumbers={contactNumbers}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextFieldProps
								label="Company Name"
								placeholder="Enter Company Name"
								value={formValues.companyName}
								onChange={(e) => handleChange('companyName', e.target.value)}
								required
								error={Boolean(errors.companyName)}
								helperText={errors.companyName || ''}
								fullWidth
								InputProps={{
									sx: { fontSize: { xs: 14, sm: 18 } },
								}}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextFieldProps
								label="Owner Name"
								placeholder="Enter Owner Name"
								value={formValues.ownerName}
								onChange={(e) => handleChange('ownerName', e.target.value)}
								required
								error={Boolean(errors.ownerName)}
								helperText={errors.ownerName || ''}
								fullWidth
								InputProps={{
									sx: { fontSize: { xs: 14, sm: 18 } },
								}}
							/>
						</Grid2>

						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextFieldProps
								label="Email Address"
								placeholder="Enter Email Address"
								value={formValues.email}
								onChange={(e) => handleChange('email', e.target.value)}
								required
								error={Boolean(errors.email)}
								helperText={errors.email || ''}
								fullWidth
								InputProps={{
									sx: { fontSize: { xs: 14, sm: 18 } },
								}}
							/>
						</Grid2>
					</Grid2>
				</Box>
			</Paper>

			{/* Address Details */}
			<Paper elevation={1} sx={{ borderRadius: '10px', mb: { xs: 3, sm: 4 } }}>
				<Box
					sx={{
						bgcolor: '#1B663C',
						p: 1,
						display: 'flex',
						alignItems: 'center',
						px: { xs: 2, sm: 3 },
						borderTopRightRadius: '12px',
						borderTopLeftRadius: '12px',
					}}
				>
					<LocationIcon
						sx={{ color: 'white', mr: 1.5, fontSize: { xs: '1rem', sm: '1.25rem' } }}
					/>
					<Typography
						sx={{
							color: 'white',
							fontSize: { xs: '14px', sm: '1rem' },
							fontFamily: 'Poppins',
						}}
					>
						Address Details
					</Typography>
				</Box>
				<Box sx={{ p: { xs: 2, sm: 3 } }}>
					<Grid2 container spacing={isMobile ? 2 : 3}>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextFieldProps
								label="Company Address"
								placeholder="Enter Company Address"
								value={formValues.companyAddress}
								onChange={(e) => handleChange('companyAddress', e.target.value)}
								required
								error={Boolean(errors.companyAddress)}
								helperText={errors.companyAddress || ''}
								fullWidth
								InputProps={{
									sx: { fontSize: { xs: 14, sm: 18 } },
								}}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextFieldProps
								label="Country"
								placeholder="Enter Country"
								value={formValues.country}
								onChange={(e) => handleChange('country', e.target.value)}
								required
								error={Boolean(errors.country)}
								helperText={errors.country || ''}
								fullWidth
								InputProps={{
									sx: { fontSize: { xs: 14, sm: 18 } },
								}}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextFieldProps
								label="State"
								placeholder="Enter State"
								value={formValues.state}
								onChange={(e) => handleChange('state', e.target.value)}
								required
								error={Boolean(errors.state)}
								helperText={errors.state || ''}
								fullWidth
								InputProps={{
									sx: { fontSize: { xs: 14, sm: 18 } },
								}}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextFieldProps
								label="City"
								placeholder="Enter City"
								value={formValues.city}
								onChange={(e) => handleChange('city', e.target.value)}
								required
								error={Boolean(errors.city)}
								helperText={errors.city || ''}
								fullWidth
								InputProps={{
									sx: { fontSize: { xs: 14, sm: 18 } },
								}}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextFieldProps
								label="ZipCode"
								placeholder="Enter zipCode"
								value={formValues.zipCode}
								onChange={(e) => handleChange('zipCode', e.target.value)}
								required
								error={Boolean(errors.zipCode)}
								helperText={errors.zipCode || ''}
								fullWidth
								InputProps={{
									sx: { fontSize: { xs: 14, sm: 18 } },
								}}
							/>
						</Grid2>
					</Grid2>
				</Box>
			</Paper>

			{/* Business Details */}
			<Paper elevation={1} sx={{ borderRadius: '10px', mb: { xs: 3, sm: 4 } }}>
				<Box
					sx={{
						bgcolor: '#1B663C',
						p: 1,
						display: 'flex',
						alignItems: 'center',
						px: { xs: 2, sm: 3 },
						borderTopRightRadius: '12px',
						borderTopLeftRadius: '12px',
					}}
				>
					<BusinessIcon
						sx={{ color: 'white', mr: 1.5, fontSize: { xs: '1rem', sm: '1.25rem' } }}
					/>
					<Typography
						sx={{
							color: 'white',
							fontSize: { xs: '14px', sm: '1rem' },
							fontFamily: 'Poppins',
						}}
					>
						Business Details
					</Typography>
				</Box>
				<Box sx={{ p: { xs: 2, sm: 3 } }}>
					<Grid2 container spacing={isMobile ? 2 : 3}>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextFieldProps
								label="Type Of Industry"
								placeholder="Enter Industry Type"
								value={formValues.industryType}
								onChange={(e) => handleChange('industryType', e.target.value)}
								required
								error={Boolean(errors.industryType)}
								helperText={errors.industryType || ''}
								fullWidth
								InputProps={{
									sx: { fontSize: { xs: 14, sm: 18 } },
								}}
							/>
						</Grid2>
						<Grid2 size={{ xs: 12, sm: 6 }}>
							<TextFieldProps
								label="GST Number"
								placeholder="Enter GST Number"
								value={formValues.gstNumber}
								onChange={(e) => handleChange('gstNumber', e.target.value)}
								required={false}
								fullWidth
								InputProps={{
									sx: { fontSize: { xs: 14, sm: 18 } },
								}}
							/>
						</Grid2>
					</Grid2>
				</Box>
			</Paper>
			{isEdit && (
				<>
					{/* Permissions */}
					<MenuTable
						permissions={formValues?.permissions}
						onChange={handlePermissionChange}
					/>
				</>
			)}

			{/* Actions */}

			<Box
				sx={{
					position: 'fixed', // fix at viewport bottom
					bottom: 0,
					left: 65,
					right: 0,
					bgcolor: 'background.paper', // ensure background covers content underneath
					boxShadow: '0 -2px 8px rgba(0,0,0,0.1)', // subtle shadow on top
					p: 1,
					zIndex: 1300, // above most content (MUI modal default zIndex is 1300)
				}}
			>
				<Grid2 container spacing={2} sx={{ mt: 1 }}>
					<Grid2
						size={{ xs: 12, sm: 12 }}
						sx={{
							display: 'flex',
							gap: 2,
							justifyContent: { xs: 'flex-start', sm: 'flex-end' },
						}}
					>
						<Button
							variant="contained"
							onClick={() => {
								window.history.back();
								localStorage.removeItem('vendorperson');
								localStorage.removeItem('otp-verified');
							}}
							fullWidth={isMobile}
							sx={{
								bgcolor: '#fb1a1aff',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '1rem',
								fontWeight: 'medium',
								borderRadius: 2,
								'&:hover': { bgcolor: '#145133' },
							}}
						>
							Cancel
						</Button>
						<Button
							variant="contained"
							onClick={HandleSubmit}
							fullWidth={isMobile}
							sx={{
								bgcolor: '#1B663C',
								color: 'white',
								fontFamily: 'Poppins',
								fontSize: '1rem',
								fontWeight: 'medium',
								borderRadius: 2,
								'&:hover': { bgcolor: '#145133' },
							}}
						>
							{isEdit ? 'Update' : 'Submit'}
						</Button>
					</Grid2>
				</Grid2>
			</Box>
			<MySnackbarModal
				open={snackbarOpen}
				action={snackbarAction}
				Message={snackbarMessage}
				onClose={() => setSnackbarOpen(false)}
				loading={loading}
			/>
			<VendoRForms
				open={verificationContact}
				onClose={() => setVerificationContact(false)}
				onOtpVerified={() => {
					localStorage.setItem('otp-verified', 'true');
					setVerificationContact(false);
					// setShowVendorForm(true);
				}}
			/>
		</Box>
	);
};

export default VendorRegistrationForm;
